export const cardResponseData = [{
  account_token: '2PISYVTENQSP3OZ',
  identifiers: {
    display_account_number: 'XXXX-XXXXXX-75008',
    is_basic: true,
    is_replaced: false,
    is_purged: false,
    sorted_index: -1,
    supplementary_account_count: 0,
    account_key: '9320F3C8AB9988DAE5F8FDD97F8D6C99',
    internal_account_number: '0000501519852190828',
    is_enrolled_online: false
  },
  platform: {
    system_platform: 'T',
    conversion_status: 'originalTriumph',
    amex_region: 'US',
    market_name: 'UnitedStates',
    market_code: '037',
    iso_country_code: '840',
    currency_code: '001',
    market_currency_code: 'USD'
  },
  holder: {
    profile: {
      first_name: 'KRISHNA',
      last_name: 'LINGAMNENI-BLAKE',
      embossed_name: 'KRISHNA LINGAMNENI-BLAKE',
      birth_date: {
        day: 1,
        month: 2,
        year: 1959
      },
      holder_since_date: '2019',
      gender: 'U',
      national_id: 'V4wtHxzYG',
      income: '00000000000',
      employer_name: 'ATDM EMPLOYER',
      is_company_name_embossed: false,
      is_account_level_embossed: true
    },
    localization_preferences: {
      localization_id: 'en-US',
      home_country_locale: 'en-US',
      currency_locale: 'en-US',
      date_locale: 'en-US',
      language_preference_code: 'EN',
      geo_country_locale: 'en-US'
    },
    contacts: {
      recent_address_change_date: '2026-04-15',
      address: [{
        purpose: ['PLASTIC', 'BILLING', 'LETTER', 'LABEL'],
        type: 'HOME',
        street_address_line1: '85 Denison Road',
        street_address_line2: '1',
        city: 'PHOENIX',
        state: 'AZ',
        country_code: 'US',
        country_name: 'UNITED STATES',
        postal_code: '850248688',
        time_zone: 'MNT',
        change_date: '2026-04-15',
        effective_date: '2026-04-15'
      }],
      phone: [{
        type: 'HOME',
        phone_number: '3533213712'
      }]
    }
  },
  product: {
    identifiers: {
      arrangement_id: '49b21e41-04ad-4a7a-8f5a-92d318599e12',
      experience_id: 'c36128dc-a4f5-41e1-882d-733fc97e5197',
      issuance_product_code: 'YB',
      design_id: 'USA_CON_CLASSIC_GOLD4_REC_EDI'
    },
    digital_info: {
      product_desc: 'Traditional Gold Card',
      product_id: 'YB',
      product_code: '111',
      product_config_code: '17',
      product_short_desc: 'RCP GOLD',
      secondary_product_type: 'C',
      abbreviated_product_desc: 'GOLD',
      digital_asset_id: 'NUS000000350',
      se_genesis_product_code: '0007',
      legal_entity_code: '08',
      legal_entity_desc: 'American Express National Bank',
      design_name: 'Classic Gold',
      form_factor: 'RECLAIMED_PLASTIC',
      voice_id: 'IVR_TraditionalGoldCard_BASIC',
      display_name: 'Reclaimed Plastic'
    },
    account_types: {
      plastic_types: ['Gold'],
      card_types: ['Gold', 'GoldTraditionalCard'],
      line_of_business_type: 'ConsumerCard',
      payment_type: 'ChargeCard',
      product_type_code: '12'
    },
    account_eligibilities: ['SignAndTravelTransferEligible', 'YearEndSummaryEligible', 'PrivatePaymentsEligible', 'NoPresetSpendingLimitEligible', 'GlobalLimitOnSuppsEligible', 'FlexSelectEligible', 'ExpoTransferEligible', 'ExpoEnrollmentEligible', 'PaperCopyEligible', 'SignAndTravelEnrollmentEligible', 'PayByPCEligible', 'OnlineDisputesEligible'],
    lending_benefits: {
      product_features: [{
        name: 'PayItPlanIt',
        enrollment_status: [{
          status: 'Enrolled'
        }]
      }]
    },
    extended_payment_terms: {
      enrollment_status: ['NotEnrolled']
    },
    account_features: {
      is_loyalty_account: true,
      loyalty: {
        legal_program_name: 'Membership Rewards&reg;',
        tier_code: 'MR'
      },
      ecoa_desc: 'INDIVIDUAL'
    }
  },
  status: {
    account_status: ['Active'],
    replacement_reasons: ['NewCard'],
    days_past_due: 0,
    account_setup_date: '2024-05-03',
    product_effective_date: '2024-05-03',
    plastic_effective_date: '2024-05-03',
    expiration_date: '2028-05-03',
    replacement_reason_code: '08',
    account_activation_required: 'ACTIVATION REQUIRED'
  }
}];
export const GpcResponse = {
  entityPreferenceResponse: {
    entityValue: 'patrickccassidy@gmail.com',
    preferenceCodeDetails: [{
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'TKTACC',
      preferenceEffectiveTs: '01-01-0001-00.00.00.000000',
      preferenceList: [],
      preferenceStatus: 'U'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'AMXCUR',
      preferenceEffectiveTs: '01-01-0001-00.00.00.000000',
      preferenceList: [],
      preferenceStatus: 'U'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'MKMEMB',
      preferenceEffectiveTs: '2026-07-03 02:25:17.964976',
      preferenceList: [],
      preferenceStatus: 'O'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'MKOFFR',
      preferenceEffectiveTs: '2026-07-03 02:25:17.946639',
      preferenceList: [],
      preferenceStatus: 'I'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'MKGIFT',
      preferenceEffectiveTs: '2026-07-03 02:25:17.982489',
      preferenceList: [],
      preferenceStatus: 'O'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'MKCORP',
      preferenceEffectiveTs: '2026-07-03 02:25:17.999565',
      preferenceList: [],
      preferenceStatus: 'I'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'MKRESR',
      preferenceEffectiveTs: '2026-07-03 02:25:18.018119',
      preferenceList: [],
      preferenceStatus: 'I'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'MKNEWS',
      preferenceEffectiveTs: '2026-07-03 02:25:18.034202',
      preferenceList: [],
      preferenceStatus: 'O'
    }, {
      derivedIndicator: 'N',
      prefLockInd: 'No',
      preferenceCode: 'GCEVNT',
      preferenceEffectiveTs: '2026-07-03 02:25:18.071612',
      preferenceList: [],
      preferenceStatus: 'O'
    }]
  },
  status: {
    requestTrackId: 'DIG_EML_1785332257779',
    responseCode: 'SUCCESS'
  }
};